<template>
    <div class="container inline center h-item-margin margin no-legend">
      <span class="check-frame" :style="maxWidth ? 'max-width: 40%' : ''">{{ options[0] }}</span>
      <label :for="name" class="switch">
        <input type="checkbox" :id="id" :name="name" v-model="checked" :disabled="disabled" />
        <span class="slider" :class="{TA:isTestAchat,disabled:disabled}" ></span>
      </label>
      <span class="check-frame" :style="maxWidth ? 'max-width: 40%' : ''">{{ options[1] }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {
    props: {
        id: {
            type: String
        },
        name: {
            type: String
        },
        options: {
            type: Array
        },
        value: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Boolean,
            default: false
        },
        default: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: this.default
        }
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    },
    watch: {
        checked(value) {
            this.$emit("input", value);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Form/SwitchField.vue